<style lang="scss">
@import '../../assets/scss/_variables.scss';

.point-input-container {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    margin: 0;
    padding-left: $grid-size;
    padding-bottom: calc(#{$grid-size} - 0.55em);
    position: relative;

    cursor: pointer;

    & + & {
        margin-top: 47px;
    }

    &:after {
        content: '';
        width: 100%;
        height: 32px;
        position: absolute;
            left: 0;
            bottom: 0;

        border: 2px solid $color-black;
        border-top: none;
        pointer-events: none;
    }

    .point-id {
        font-family: $font-family-2;
        font-size: 28px;
        font-weight: bold;
        color: $color-text-1;
        text-transform: uppercase;
        user-select: none;
    }

    .vue-autocomplete {
        flex: 1 1 auto;
        margin-left: 17px;

        input {
            width: 100%;
            padding-right: 20px;

            font-size: 22px;
            color: $color-white;

            border: none;
            appearance: none;
            background: none;

            &::placeholder {
                color: $color-white;
            }

            &:focus {
                outline: none
            }
        }

        .vue-dropdown {
            display: flex; // to make the list as big as the content
            width: 100%;
            padding-bottom: $mobile-pad;
            position: absolute;
                top: 100%;
                left: 0;

            ul {
                overflow: auto;
            }
        }
    }

    @include media-smaller('md') {
        padding-left: $mobile-pad;
        padding-bottom: calc(#{$mobile-pad} - 0.55em);

        & + & {
            margin-top: 37px;
        }
    }
}
</style>

<template>
    <label :for="id" ref="container" class="point-input-container">
        <span class="point-id">{{ point }}.</span>

        <Autocomplete
            @focus="handleFocus"
            @input="handleInput"
            @selected="handleSelected"
            @blur="handleBlur"
            value-prop="description"
            :name="id"
            :placeholder="placeholder"
            :items="results"
        >
            <template slot="item" slot-scope="slot">
                {{ slot.data.description }}
            </template>
        </Autocomplete>
    </label>
</template>

<script>
import scroller from 'vue-scrollto';
import PlacesAutocomplete from './PlacesAutocomplete';

export default {
    extends: PlacesAutocomplete,
    props: ['point'],
    computed: {
        id () {
            return 'form-point-' + this.point;
        }
    },
    methods: {
        handleFocus () {
            if (this.$refs.container && this.$store.getters.viewport < 2) {
                scroller.scrollTo(this.$refs.container, {
                    duration: 400,
                    offset: -15
                });
            }
        },
        handleBlur () {
            this.$emit('blur', this.activeValue);
        }
    }
};
</script>
